exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".groupBarWithoutAxis .barstext, .groupBarWithoutAxis__label {\n  font-size: 10px; }\n\n.groupBarWithoutAxis .axis text {\n  font-size: 10px !important; }\n\n.groupBarWithoutAxis__label {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  padding: 5px 0 2px 0; }\n  .groupBarWithoutAxis__label span {\n    width: 10px;\n    height: 10px;\n    background-color: #4472c4;\n    margin: 0 5px 0 5px; }\n\n.groupBarWithoutAxis_no_data {\n  text-transform: uppercase;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/d3Components/groupBarWithoutAxis/groupBarWithoutAxis.style.scss
// module id = 1624
// module chunks = 0